import { render, staticRenderFns } from "./main-professionalism-dialog.vue?vue&type=template&id=67dc22ec&scoped=true"
import script from "./main-professionalism-dialog.vue?vue&type=script&lang=js"
export * from "./main-professionalism-dialog.vue?vue&type=script&lang=js"
import style0 from "./main-professionalism-dialog.vue?vue&type=style&index=0&id=67dc22ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dc22ec",
  null
  
)

export default component.exports